var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6133 18.6667H20.6667L27.32 25.3333L25.3333 27.32L18.6667 20.6667V19.6133L18.3067 19.24C16.7867 20.5467 14.8133 21.3333 12.6667 21.3333C7.88 21.3333 4 17.4533 4 12.6667C4 7.88 7.88 4 12.6667 4C17.4533 4 21.3333 7.88 21.3333 12.6667C21.3333 14.8133 20.5467 16.7867 19.24 18.3067L19.6133 18.6667ZM6.66667 12.6667C6.66667 15.9867 9.34667 18.6667 12.6667 18.6667C15.9867 18.6667 18.6667 15.9867 18.6667 12.6667C18.6667 9.34667 15.9867 6.66667 12.6667 6.66667C9.34667 6.66667 6.66667 9.34667 6.66667 12.6667Z",
    fill: "inherit",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a5df502dd2a7d52fe406a933d4afb0e9.svg";
export { ForwardRef as ReactComponent };